import React, { useState, useEffect } from 'react'
import { FavoriteTeam } from './FavoriteTeam'
import { FavoriteTeamSection } from './FavoriteTeamSection'
import { useAuthContext } from '../../Context'

export const FavoriteTeamCon: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { favTeam } = useAuthContext()
  const [showFavTeam, setShowFavTeam] = useState<boolean>(false)

  useEffect(() => {
    if (favTeam) {
      setShowFavTeam(true)
    } else {
      setShowFavTeam(false)
    }
  }, [favTeam])

  return <>{!showFavTeam ? <FavoriteTeam /> : <FavoriteTeamSection />}</>
}
